import Huebee from 'huebee';

document.addEventListener('turbo:load', () => {
  const huebee = document.querySelector('.huebee');
  if (huebee) {
    new Huebee(huebee, {
      customColors: ['#F96302', '#ED2893', '#CC00A0', '#56008C', '#0051BA', '#008ED6', '#00BCE2', '#00B59B', '#8CD600', '#BAD80A', '#FFED38', '#FFFFFF'],
      notation: 'hex',
      shades: 0,
      staticOpen: false, // COMBAK: change default to true, address with: https://github.com/metafizzy/huebee/pull/20
    });
  }
});